import { useTransparentRef } from '@Hooks/useTransparentRef';
import { HtmlEditor } from '@synqo/frontend-component-library';
import { type FC } from 'react';
import { type ControlProps } from '../props';
import { useUpdateCustomization } from '../useUpdateCustomization';

export const HtmlEditorControl: FC<ControlProps> = ({ data, locked, updateData }) => {
    const { state, setState } = useUpdateCustomization(data, updateData);

    // When the `value` prop of HtmlEditor changes, and it contains trailing or leading spaces,
    // they are removed. Don't ask me why. To combat that, and since the HtmlEditor
    // is a controlled component anyway, I am enforcing that `value` stays constant while
    // the component is editable, and simply mirrors the props when the component is not editable.
    const initialValue = useTransparentRef(state, !!locked);

    return (
        <HtmlEditor
            value={initialValue.current}
            label={data.label}
            onHtmlChange={setState}
            allowImages={false}
            allowLinks={false}
            enterIsNewLine
            readOnly={locked}
            id={data.name}
        />
    );
};
